module.exports = __webpack_public_path__ + "img/mergeWithLast.c8ecf0b6.svg";